<template>
	<div>
		<div id="top"></div>
			<!-- Header -->
			<Header @toggleMenu='toggleMenu' :phone_number="phone_number.sm"></Header>
			<div class="pt-75"></div>
			<template v-if="is_load">
				<img src="../assets/icon/loading.gif" class="mx-auto d-block" width="150">
			</template>
			<template v-else>
				<div>
					<div class="bg-green">
						<div class="container pl-4 py-3" style="padding-right: 0!important;background-color: #1a6540!important">
							<!-- Banner -->
							<div 
								data-aos="fade-up" 
								data-aos-duration="1500"
								class="rounded-6">
								<flickity ref="flickity" class="banner text-center"
				          :options="flickityOptions">
				          <!-- Gold -->
				          <div class="carousel-cell w-90 bg-white rounded-6 border-gold">
				            <div class="banner w-100">
				              <div class="pl-4 pr-2 py-3 text-left">
		              			<p class="mb-0 font-semibold text-18 color-black">Harga <span class="color-gold font-semibold text-18">Emas</span> Hari Ini</p>
				              	<p class="mb-2 font-regular text-12 color-grey">Kami membeli dengan harga emas tertinggi</p>
				              	<div class="d-block">
					              	<p class="mb-0 font-semibold text-16 color-black">24 Karat</p>
					              	<p class="mb-2 font-semibold text-24 color-green">Rp {{formatPrice(real_price.emas)}} <span class="text-12 color-black">/gram</span></p>
				              	</div>
				              	<button type="button" class="button-primary px-3 py-2 text-12 h-auto" @click="toggleMenu('check-price-id');toggleOpen('gold')">CEK HARGA</button>
				              	<!-- Slide -->
				              	<div class="div-wrapper pt-3 text-truncate mx-auto d-block w-100">
													<div class="text-center" style="width: max-content">
									          <div class="d-inline-block rounded-6 py-1 px-2 border-gold">
									            <div class="w-100">
									            	<p class="mb-0 text-12 font-regular color-black">18 Karat</p>
									            	<p class="mb-0 text-12 font-semibold color-black">Rp {{formatPrice(carat_18)}}</p>
									            </div>
									          </div>
									          <div class="d-inline-block rounded-6 py-1 px-2 border-gold">
									            <div class="w-100">
									            	<p class="mb-0 text-12 font-regular color-black">14 Karat</p>
									            	<p class="mb-0 text-12 font-semibold color-black">Rp {{formatPrice(carat_14)}}</p>
									            </div>
									          </div>
									          <div class="d-inline-block rounded-6 py-1 px-2 border-gold">
									            <div class="w-100">
									            	<p class="mb-0 text-12 font-regular color-black">9 Karat</p>
									            	<p class="mb-0 text-12 font-semibold color-black">Rp {{formatPrice(carat_9)}}</p>
									            </div>
									          </div>
										      </div>
										    </div>
				              </div>
				            </div>
				          </div>
				          <div class="carousel-cell w-90 bg-banner-gold rounded-6 border-gold">
				            <div class="banner w-100">
				              <div class="container py-3 text-left">
				              	<p class="mb-2 font-semibold text-14 color-black">Jual Beli Perhiasan <span class="color-gold font-semibold text-14">Emas</span> dan <span class="color-silver font-semibold text-14">Silver</span> <br>dengan Harga Terbaik</p>
					              <p class="mb-0 mt-1 font-bold text-24 color-black d-table rounded-6" @click="toggleMenu('check-price-id')">
				              		Tanpa Surat <br>	
													Tanpa Ribet <br>
													Tanpa Repot <br>
					              </p>
				              </div>
				            </div>
				          </div>
				          <!-- Silver -->
				          <div class="carousel-cell w-90 bg-white rounded-6 border-silver">
				            <div class="banner w-100">
				              <div class="container py-3 text-left">
				              	<p class="mb-0 font-semibold text-18 color-black">Harga <span class="color-silver font-semibold text-18">Silver</span> Hari Ini</p>
				              	<p class="mb-2 font-regular text-12 color-grey">Kami membeli dengan harga silver <br>tertinggi</p>
				              	<div class="d-block">
					              	<p class="mb-0 font-semibold text-16 color-black">925 Kualitas</p>
					              	<p class="mb-2 font-semibold text-24 color-green">Rp {{formatPrice(quality_925)}} <span class="text-12 color-black">/gram</span></p>
				              	</div>
				              	<button type="button" class="button-primary px-3 py-2 text-12 h-auto" @click="toggleMenu('check-price-id');toggleOpen('silver')">CEK HARGA</button>
				              	<!-- Slide -->
				              	<div class="div-wrapper pt-3 text-truncate mx-auto d-block w-100">
													<div class="text-center" style="width: max-content">
									          <div class="d-inline-block rounded-6 py-1 px-2 border-silver">
									            <div class="w-100">
									            	<p class="mb-0 text-12 font-regular color-black">925</p>
									            	<p class="mb-0 text-12 font-semibold color-black">Rp {{formatPrice(quality_925)}}</p>
									            </div>
									          </div>
									          <div class="d-inline-block rounded-6 py-1 px-2 border-silver">
									            <div class="w-100">
									            	<p class="mb-0 text-12 font-regular color-black">500</p>
									            	<p class="mb-0 text-12 font-semibold color-black">Rp {{formatPrice(quality_500)}}</p>
									            </div>
									          </div>
										      </div>
										    </div>
				              </div>
				            </div>
				          </div>
				          <div class="carousel-cell w-90 bg-banner-silver rounded-6 border-silver">
				            <div class="banner w-100">
				              <div class="container py-3 text-left">
				              	<p class="mb-0 font-bold text-24 color-black">BISA COD <br> TOKO MITRA <br> GOJEKIN AJA</p>
					              <p class="mb-2 font-semibold text-20 color-black">BAYAR DITEMPAT</p>
					              <p class="mb-0 font-bold text-14 color-black d-table border-gold rounded-6" @click="toggleMenu('check-price-id')" style="padding: 0.25rem 14px">Jual Emas jadi <br>lebih Nyaman !</p>
				              </div>
				            </div>
				          </div>
				        </flickity>
							</div>
						</div>
					</div>
					<!-- <div class="w-100">
						<div class="row mb-4 border-grey no-gutters text-center">
							<div class="col-6 py-11px bg-white-light delay cursor-pointer" 
								v-for="data in product_category"
								@click="toggleProductCategory(data.url)"
								:class="{'bg-white':data.active}">
								<div class="circle-icon-small d-inline-block">
									<img :src="data.icon" width="24" style="position: relative;top: 4px;">
								</div>
								<p class="mb-0 pl-2 position-relative font-regular d-inline-block text-14 color-grey ls-2" 
									:class="{'font-semibold color-green':data.active}"
									style="top: 5px">
									{{data.name}}
								</p>
							</div>
						</div>
					</div> -->
					<!-- Tabel Emas -->
					<div class="bg-white mt-4 pt-2">
						<div class="container px-4 pb-5">
							<h3 class="mb-4 color-black text-center">Harga Beli Emas Hari Ini</h3>
							<div class="border cursor-pointer rounded" @click="popUpTabelGold()">
								<div class="bg-green-light rounded-top p-3">
									<div class="row no-gutters">
										<div class="col-7">
											<p class="mb-0 text-15 font-semibold">Karat</p>
										</div>
										<div class="col-5 text-right">
											<p class="mb-0 text-15 font-semibold">Harga</p>
										</div>
									</div>
								</div>
								<div class="rouded-bottom px-3 pt-3">
									<div class="row no-gutters mb-3" v-for="data in descending_unit.slice(1,7)" v-if="data.type == 'gold'">
										<div class="col-7">
											<p class="mb-0 text-14 font-medium">K{{data.name}}</p>
										</div>
										<div class="col-5 text-right">
											<p class="mb-0 text-14 font-medium">Rp {{formatPrice(tableListPriceGold(data.murni))}} /g</p>
										</div>
									</div>
								</div>
							</div>
							<button type="button" class="button-primary w-100 mt-3" @click="toggleMenu('check-price-id');toggleOpen('gold')">Mulai Transaksi</button>
						</div>
					</div>
					<!-- Tabel Silver -->
					<div class="bg-white">
						<div class="container px-4 pb-5">
							<h3 class="mb-4 color-black text-center">Harga Beli Silver Hari Ini</h3>
							<div class="border rounded">
								<div class="bg-green-light rounded-top p-3">
									<div class="row no-gutters">
										<div class="col-7">
											<p class="mb-0 text-15 font-semibold">Kualitas</p>
										</div>
										<div class="col-5 text-right">
											<p class="mb-0 text-15 font-semibold">Harga</p>
										</div>
									</div>
								</div>
								<div class="rouded-bottom px-3 pt-3">
									<div class="row no-gutters mb-3" v-for="data in get_quality_unit" v-if="data.type == 'silver'">
										<div class="col-7">
											<p class="mb-0 text-14 font-medium">K{{data.name}}</p>
										</div>
										<div class="col-5 text-right">
											<p class="mb-0 text-14 font-medium">Rp {{formatPrice(tableListPriceSilver(data.quality))}} /g</p>
										</div>
									</div>
								</div>
							</div>
							<button type="button" class="button-primary w-100 mt-3" @click="toggleMenu('check-price-id');toggleOpen('silver')">Mulai Transaksi</button>
						</div>
					</div>
					<!-- KALKULATOR -->
					<div id="check-price-id" class="position-relative" style="top: -98px;"></div>
					<div class="container px-4 pb-5 bg-white position-relative">
						<!-- Title -->
						<div class="mb-3 pb-1">
							<div class="position-relative" id="check-price" style="top: 10px"></div>
							<p
								data-aos="fade-up" 
								data-aos-duration="1500"
								class="mb-1 font-bold text-20 color-black ls-2">Masukan 
								<span class="font-bold text-20 color-black ls-2" v-if="is_open == 'gold'">Emasmu</span> 
								<span class="font-bold text-20 color-black ls-2" v-else>Silvermu</span> 
								Di Sini</p>
							<p
								data-aos="fade-up" 
								data-aos-duration="1500"
							 	class="mb-0 font-regular text-14 color-grey ls-2">Silahkan gunakan kalkulator berikut untuk memprediksi harga emas/silver anda.</p>
						</div>
						<!-- Calculator -->
						<div 
							data-aos="fade-up" 
							data-aos-duration="1500"
							class="p-4 bg-white rounded-6 box-shadow">
							<div class="">
								<div class="row mb-4 border-grey no-gutters text-center">
									<div class="col-6 py-2 rounded-6 bg-white-light delay cursor-pointer" 
										v-for="data in category"
										@click="toggleOpen(data.type)"
										:class="{'bg-green':data.type == is_open}">
										<p class="mb-0 pl-1 font-regular text-14 color-grey ls-2" 
											:class="{'font-medium color-white':data.type == is_open}">
											{{data.name}}
										</p>
									</div>
								</div>
								<div class="row no-gutters">
									<div class="col-12 mb-3">
										<label v-if="is_open == 'gold'">Berat Emas Anda :</label>
										<label v-else>Berat Silver Anda :</label>
										<div class="row border-1 no-gutters rounded-6" @click="focusRefs('input-gram')" :class="{'border-black':focus.gram}">
											<div class="col-8">
												<input type="number" placeholder="Masukan berat" 
												v-model="form.gram" 
												ref="input-gram"
												@focus="toggleForm('focus', 'gram')" 
												@blur="toggleForm('blur', 'gram')" 
												class="w-100 border-none" />
											</div>
											<div class="col-4 text-right">
												<label class="bg-white position-relative pl-2 pr-3 py-2" style="top: 4px">/gram</label>
											</div>
										</div>								
									</div>
									<!-- GOLD -->
									<div class="col-12 mb-3" v-show="is_open == 'gold'">
										<label>Jumlah Karat :</label>
										<div class="row border-1 no-gutters rounded-6" :class="{'border-black':focus.karat}">
											<div class="col-9">
												<span 
													v-if="form.quality == '' || form.quality == undefined"
													class="font-regular text-14 position-absolute" 
													style="color: #E4E4E4!important;padding: 13px 16px;z-index: 8">Masukan jumlah karat</span>
												<select 
													v-model="form.price" 
													:value="form.carat"
													@focus="toggleForm('focus', 'karat')" 
													@blur="toggleForm('blur', 'karat')"
													@change="toggleSelectCarat(form.price);" 
													class="w-100 rounded-6 border-none position-relative"
													style="background: transparent;z-index: 9">
													<option class="cursor-pointer" v-for="data in get_quality_unit" v-if="data.type == 'gold'" :value="data">{{data.name}}</option>
												</select>
											</div>
											<div class="col-3 text-right">
												<label class="bg-white position-relative p-2" style="top: 4px;right: 5px">karat</label>
											</div>
										</div>
									</div>
									<!-- SILVER -->
									<div class="col-12 mb-3" v-show="is_open == 'silver'">
										<label>Jenis Kualitas :</label>
										<div class="row border-1 no-gutters rounded-6" :class="{'border-black':focus.karat}">
											<div class="col-8">
												<span 
													v-if="form.quality == '' || form.quality == undefined"
													class="font-regular text-14 position-absolute" 
													style="color: #E4E4E4!important;padding: 13px 16px;z-index: 8">Masukan jenis kualitas</span>
												<select 
													v-model="form.price" 
													:value="form.carat"
													@focus="toggleForm('focus', 'karat')" 
													@blur="toggleForm('blur', 'karat')"
													@change="toggleSelectCarat(form.price)" 
													class="w-100 rounded-6 border-none position-relative"
													style="background: transparent;z-index: 9">
													<option class="cursor-pointer" v-for="data in get_quality_unit" v-if="data.type == 'silver'" :value="data">{{data.name}}</option>
												</select>
											</div>
											<div class="col-4 text-right">
												<label class="bg-white position-relative p-2" style="top: 4px;right: 4px;">kualitas</label>
											</div>
										</div>
									</div>
									<div class="col-12 mb-1 text-center" v-if="form.gram != '' && form.carat != ''">
											<div class="py-2 rounded-6 delay cursor-pointer" 
												data-aos="zoom-in"
												style="background-color: #efb93f2b"
												@click="toggleCart()">
												<label class="pb-0 color-grey px-2">‘Penawaran Harga Tertinggi emas anda’</label>
												<p class="mb-0 font-semibold text-30 color-green" :class="{'color-white':is_open == 'gold', 'color-white':is_open == 'silver'}">Rp {{formatPrice(isPrice)}}</p>
											</div>
									</div>
								</div>
								<!-- Button Check Price -->
								<div class="mb-1 mt-3" v-if="form.gram != '' && form.carat != ''">
									<button type="button" class="button-primary w-100" @click="toggleCart();">
										<span>Lanjut <img src="../assets/icon/right-arrow-white.svg" width="20" /></span>
									</button>
								</div>
							</div>
						</div>
					</div>
					<!-- Chart -->
					<div class="bg-white">
						<div class="container px-4 pb-5">
							<h3 class="mb-4 color-black text-center">Live Grafik Harga Emas</h3>
							<div class="banners w-100 rounded-6 border border-green" style="background-color: #f0bc471a;z-index: 80">
              	<iframe src="https://goldbroker.com/widget/live/XAU?currency=USD&height=320" class="pt-3" scrolling="no" frameborder="0" width="100%" height="320" style="border: 0; overflow: hidden;"></iframe>
	            </div>
						</div>
					</div>
					<div class="bg-white">
						<div class="container px-4 pb-5">
							<h3 class="mb-4 color-black text-center">Live Grafik Harga Silver</h3>
							<div class="banners w-100 rounded-6 border-silver" style="background-color: #c0c0c01a;z-index: 80">
              	<iframe src="https://goldbroker.com/widget/live/XAG?currency=USD&height=320" class="pt-3" scrolling="no" frameborder="0" width="100%" height="320" style="border: 0; overflow: hidden;"></iframe>
	            </div>
						</div>
					</div>
					<div class="bg-light">
					<div id="how-to" class="position-relative" style="top:-55px"></div>
						<div class="container p-4">
							<h3 class="mb-4 pb-3 pt-4 color-black text-center">Cara Kerja Goemas</h3>
							<div class="row no-gutters mb-4 pb-2">
								<div class="col-3">
									<img src="../assets/icon/empty.svg" width="75" class="object-fit">
								</div>
								<div class="col-9">
									<div class="pl-2">
										<p class="mb-2 font-semibold text-16 color-black">Gratis Cek Perkiraan Harga</p>
					    			<p class="mb-0 font-regular text-14 color-grey">Masukan data emas/silver anda dan dapatkan langsung perkiraan harga jual sesuai berat dan karatnya.</p>
									</div>
								</div>
							</div>
							<div class="row no-gutters mb-4 pb-2">
								<div class="col-3">
									<img src="../assets/icon/under_construction.svg" width="75" class="object-fit">
								</div>
								<div class="col-9">
									<div class="pl-2">
										<p class="mb-2 font-semibold text-16 color-black">Gratis Pengecekan Barang</p>
					    			<p class="mb-0 font-regular text-14 color-grey">Pihak Mitra akan datang langsung ke tempat anda untuk mengecek berat dan kadar karat emas/silver anda secara jujur aman dan terpercaya dengan tetap menerapkan protokol kesehatan.</p>
									</div>
								</div>
							</div>
							<div class="row no-gutters mb-4 pb-2">
								<div class="col-3">
									<img src="../assets/icon/smartphone.svg" width="75" class="object-fit">
								</div>
								<div class="col-9">
									<div class="pl-2">
										<p class="mb-2 font-semibold text-16 color-black">Cepat Dapatkan Uang</p>
					    			<p class="mb-2 font-regular text-14 color-grey">Jika dibandingkan dengan tempat lain, harga GOEMAS merupakan harga yang tertinggi tanpa ada biaya admin dan komisi.</p>
										<p class="mb-0 font-regular text-14 color-grey">Tersedia layanan 
											<ul class="mb-0">
												<li class="font-regular text-14 color-grey mb-0">COD</li>
												<li class="font-regular text-14 color-grey mb-0">Toko Mitra</li>
												<li class="font-regular text-14 color-grey mb-0">Gojekin Aja</li>
											</ul> tanpa biaya tambahan.</p>
									</div>
								</div>
							</div>
				    </div>
					</div>
					<!-- Why Choose GoGold -->
					<div class="bg-white">
					<div id="about-us" class="position-relative" style="top:-30px"></div>
						<div class="container px-4">
							<div class="mb-5 pt-5 text-center">
								<h3
									data-aos="fade-up" 
									data-aos-duration="1000" 
									class="mb-4 pb-3 color-black text-center">Mengapa Memilih Kami</h3>
								<div class="row slim-grid-row">
									<div class="col-12 mb-4">
										<div 
											data-aos="fade-up" 
											data-aos-duration="1000" 
											class="p-4 bg-white rounded-6 box-shadow">
											<div class="my-3">
												<div class="position-relative">
													<img src="../assets/img/best-price.png" width="75" height="75">
												</div>
												<p class="mb-2 mt-3 font-semibold text-16 color-black">Best Price</p>
												<p class="mb-0 font-regular text-14 color-grey">Jual emas/silver dengan harga terbaik.</p>
											</div>
										</div>
									</div>
									<div class="col-12 mb-4" v-for="data in about_us">
										<div 
											data-aos="fade-up" 
											data-aos-duration="1000" 
											class="p-4 bg-white rounded-6 box-shadow">
											<div class="my-3">
												<div class="position-relative">
													<img :src="data.icon" width="64" height="64">
													<div class="position-absolute circle-icon"></div>
												</div>
												<p class="mb-2 mt-3 font-semibold text-16 color-black">{{data.title}}</p>
												<p class="mb-0 font-regular text-14 color-grey">{{data.desc}}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Comming Soon -->
					<div class="" style="background-color: #fae6b96b">
						<div class="">
							<div
								data-aos="fade-zoom-in"
								data-aos-duration="1000"
								class="container px-4 py-5 text-center">
								<h3 class="mb-1 text-center">Segera Hadir Layanan <span class="h3 color-green">Go</span><span class="h3 color-gold">Emas</span></h3>
								<h3 class="mb-1 pt-1 color-black text-center">Pada Platform</h3>
								<h3 class="mb-4 pt-1 color-black text-center">Google Play & App Store</h3>
								<img src="../assets/icon/googleplay.png" class="d-inline-block mr-2" width="130" style="cursor: no-drop">
								<img src="../assets/icon/appstore.png" class="d-inline-block" width="130" style="cursor: no-drop">
							</div>
						</div>
					</div>
					<!-- Question -->
					<div class="question-bg">
						<div class="question-opacity">
							<div
								data-aos="fade-zoom-in"
								data-aos-duration="1000"
								class="container px-4 py-5 text-center">
								<h3 class="mb-4 color-white text-center">Butuh Bantuan?</h3>
								<p class="mb-3 font-regular text-16 color-light">Hubungi kami jika kamu memiliki pertanyaan atau kesulitan saat ingin menjual atau membeli emas/silver.</p>
								<a :href="'https://api.whatsapp.com/send?phone='+phone_number.sm+'&text=Halo,%20saya%20memiliki%20pertanyaan,'" target="_blank">
									<button type="button" class="button-primary px-4 text-14">Hubungi Kami</button>
								</a>
							</div>
						</div>
					</div>
					<!-- Media social -->
					<div class="bg-white">
						<div class="container px-4 py-5">
							<h3 class="mb-4 color-black text-center">Media Sosial Kami</h3>
							<div class="row no-gutters text-center">
								<div class="col-3">
									<a :href="social_media.instagram_sm" target="_blank">
										<img src="../assets/icon/instagram.svg" width="35" class="object-fit">
									</a>
								</div>
								<div class="col-3">
									<a :href="social_media.facebook_sm" target="_blank">
										<img src="../assets/icon/facebook.svg" width="35" class="object-fit">
									</a>
								</div>
								<div class="col-3">
									<a :href="social_media.youtube_sm" target="_blank">
										<img src="../assets/icon/youtube.png" width="40" class="object-fit">
									</a>
								</div>
								<div class="col-3">
									<a :href="'https://vt.tiktok.com/ZSe2xsASp/'" target="_blank">
										<img src="../assets/icon/tik-tok.png" width="38" class="object-fit">
									</a>
								</div>
							</div>
						</div>
					</div>
					<!-- Footer Web -->
					<div class="bg-light">
						<div class="container px-4 py-4">
							<div class="row no-gutters pb-1">
								<div class="col-12">
									<img src="../assets/goemas.png" width="150" class="object-fit position-relative" style="left: -3px;">
									<p class="my-2 font-bold text-16">PT. GOEMAS NIAGA SOLUSI</p>
									<p class="mb-0 font-medium text-14">Jalan Hang Tuah Nomor. 2 Renon</p>
									<p class="mb-0 font-medium text-14">Renon, Denpasar Selatan</p>
									<p class="mb-0 font-medium text-14">Kota Denpasar Bali</p>
								</div>
							</div>
						</div>
					</div>
					<div class="h-80px bg-light"></div>
					<div class="bg-light" style="height: 45px" v-if="getCart().length > 0"></div>
				</div>
				<!-- CART POP UP -->
		    <transition name="list">
					<template v-if="getCart().length > 0">
		        <div class="">
		          <div class="position-relative">
		            <div class="row no-gutters justify-content-center">
		              <div class="fixed-bottom d-block nav-bottom" @click="is_pop_up = true" style="z-index: 98;bottom: 82px">
		                <div class="custom-container-fluid px-0">
		                  <div class="row justify-content-center">
		                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
		                      <div class="px-4 py-2 mx-4 bg-green box-shadow-cart rounded-6 position-relative cursor-pointer">
		                        <div class="row slim-grid-row">
		                        	<div class="col-9">
		                        		<p class="mb-0 font-regular text-14 color-white pt-1">{{getCart().length}} barang di keranjang</p>
		                        	</div>
		                        	<div class="col-3 text-right">
								                <img src="../assets/icon/shopping-bag.svg" width="30">
		                        	</div>
		                        </div>
		                      </div>
		                    </div>
		                  </div>
		                </div>
		              </div>
		            </div>
		          </div>
		        </div>
		    	</template>
		    </transition>
			</template>
			<!-- POP UP CART LIST -->
	    <transition name="list">
				<template v-if="is_pop_up">
          <div class="position-relative">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom" :class="{'top-10':getCart().length > 4}"  style="z-index: 1036;">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="px-4 bg-white rounded-top-6 position-relative" :class="{'popup-full':getCart().length > 4}">
                        <div class="pb-3 pt-4 border-bottom">
                        	<div class="d-block" @click="togglePopUp()">
						                <img src="../assets/icon/close.svg" width="15" class="d-inline-block position-relative cursor-pointer" style="top: -2px">
	                        	<p class="mb-1 px-1 font-semibold text-16 ls-2 d-inline-block ml-2">Keranjang Anda</p>
                        	</div>
                        	<p class="mb-0 font-regular text-12 ls-2 color-grey">Berikut adalah emas/silver yang Anda timbang. Klik 'Tambah' untuk menambah emas/silver Anda</p>
                        </div>
                        <template v-if="getCart().length > 0">
	                        <div class="py-3">
	                        	<!-- PRODUCT -->
	                        	<div class="row slim-grid-row mb-3" v-for="data in getCart()">
	                        		<div class="col-1">
	                        			<div class="circle-icon-cart d-inline-block align-top">
																	<img src="../assets/icon/gold.svg" width="50" class="mx-auto d-block" style="position: relative;top: 5px;" v-if="data.item_type == 'GOLD'">
																	<img src="../assets/icon/silver.svg" width="50" class="mx-auto d-block" style="position: relative;top: 5px;" v-else>
																</div>
	                        		</div>
	                        		<div class="col-9">
																<div class="pl-4 ml-3">
																	<p class="mb-0 ls-2 font-semibold text-14" :class="{'color-gold':data.item_type == 'GOLD', 'color-silver':data.item_type == 'SILVER'}" style="text-transform: capitalize;">{{formatTypeItem(data.item_type)}}</p>
																	<p class="mb-0 font-medium text-14">{{data.weight}} gram, {{data.carat}} 
																		<span v-if="data.item_type == 'GOLD'">karat</span>
																		<span v-else>kualitas</span></p>
																	<p class="mb-0 font-medium text-14">Rp {{formatPrice(data.price)}}</p>
																</div>
															</div>
	                        		<div class="col-2 text-right">
																<p class="mb-0 font-regular text-12 text-danger underline cursor-pointer" @click="toggleDeleteCart(data.id)">Hapus</p>
															</div>
	                        	</div>
	                        	<div class="d-inline-block" @click="togglePopUp()">
	                        		<p class="mb-0 font-medium color-green underline text-12 ls-2 cursor-pointer">
	                        			<img src="../assets/icon/plus-green.svg" class="position-relative" width="10" style="top: -2px" />
	                        			<span class="ml-2">Tambah</span>
	                        		</p>
	                        	</div>
	                        </div>
	                        <div class="py-3" :class="{'pb-4':getCart().length > 4}">
		                        <button type="button" class="button-primary w-100" @click="toggleLocation('2')">Lanjut <img src="../assets/icon/right-arrow-white.svg" width="20" /></button>
	                        </div>
	                      </template>
	                      <template v-else>
	                      	<div class="py-4 text-center">
	                      		<img src="../assets/icon/empty.svg" width="135">
    												<p class="mb-2 mt-3 font-regular text-14 color-black">Keranjang Anda masih kosong.</p>
    												<p class="px-4 py-2 text-12 color-green underline font-semibold cursor-pointer" @click="togglePopUp()">Timbang Barang</p>
	                      	</div>
	                      </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
	    	</template>
	    </transition>
	    <!-- POP UP TYPE -->
	    <transition name="list">
				<template v-if="is_pop_up_type">
          <div class="position-relative">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom" style="z-index: 1038;bottom: 0">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="px-4 bg-white rounded-top-6 position-relative">
                        <div class="pb-3 pt-4 border-bottom">
                        	<div class="d-block" @click="toggleBack('to-item')">
						                <img src="../assets/icon/left-arrow.svg" width="20" class="d-inline-block position-relative cursor-pointer" style="top: -2px">
	                        	<p class="mb-1 px-1 font-semibold text-16 ls-2 d-inline-block ml-2">Pilih Tipe Pertemuan</p>
                        	</div>
                        	<p class="mb-0 font-regular text-12 ls-2 color-grey">Pilih tipe pertemuan yang Anda ingin lakukan dengan mitra Goemas untuk menafsir emas/silver yang Anda tawarkan.</p>
                        </div>
                        <div class="pb-2">
                        	<div class="mt-3 border p-3 rounded-6 cursor-pointer hover-box" v-for="data in transaction_list" @click="toggleTransactionType(data.id)" :class="{'bg-green-light':transaction_type == data.id}">
                        		<div class="row no-gutters">
	                        		<div class="col-1">	
	                        			<div class="mx-auto d-block radio-button position-relative" style="top: 4px" :class="{'border-green':transaction_type == data.id}">
	                        				<div class="active" v-if="transaction_type == data.id"></div>
	                        			</div>
	                        		</div>
	                        		<div class="col-11">
	                        			<div class="pl-2">
	                        				<p class="mb-0 font-semibold text-16">{{data.title}}</p>
	                        				<p class="mb-0 font-regular text-12" v-html="data.desc"></p>
	                        			</div>
	                        		</div>
	                        	</div>
                        	</div>
                        	<p class="mb-0 mt-1 font-regular text-12 text-danger" v-if="form_validate.type_transaction && transaction_type == '' ">Mohon pilih Tipe Pertemuan yang Anda ingin lakukan dengan mitra Goemas</p>
                        </div>
                        <div class="py-3">
                        	<button type="button" class="button-primary w-100 overflow-hidden" v-if="is_load_state">
                        		<img src="../assets/icon/loading-white.gif" width="80" class="position-relative top_18" />
                        	</button>
                        	<button type="button" class="button-primary w-100" v-else @click="toggleLocation('3');toggleValidation('type_transaction');geolocate()">
                        		<span>Lanjut <img src="../assets/icon/right-arrow-white.svg" width="20" /></span>
                        	</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
	    	</template>
	    </transition>
	    <!-- POP UP LOCATION SHOP -->
	    <transition name="list">
				<template v-if="is_pop_up_shop">
          <div class="position-relative">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom" style="z-index: 1038;bottom: 0">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="px-4 bg-white rounded-top-6 position-relative">
                        <div class="pb-3 pt-4 border-bottom">
                        	<div class="d-block" @click="toggleBack('to-type')">
						                <img src="../assets/icon/left-arrow.svg" width="20" class="d-inline-block position-relative cursor-pointer" style="top: -2px">
		                        <p class="mb-1 px-1 font-semibold text-16 ls-2 d-inline-block ml-2">Pilih Mitra Toko Lokasi</p>
                        	</div>
                        	<p class="mb-0 font-regular text-12 ls-2 color-grey">Pilih lokasi mitra toko yang tersedia yang Anda ingin untuk lokasi mitra Goemas untuk menafsir emas/silver yang Anda tawarkan.</p>
                        </div>
                        <div class="pt-2">
                        	<label class="color-black">Provinsi: *</label>
                        	<v-select class="w-100 mb-3" :options="provinces" v-model="provinces_selected" @input="toggleSelectProvinces(provinces_selected)" label="name"></v-select>
                        	<template v-if="provinces_selected != null && provinces_selected !=''">
                        		<label class="color-black">Kabupaten/Kota: *</label>
	                        	<template v-if="is_load_regencies">
															<img src="../assets/icon/loading.gif" class="mx-auto d-block" width="100">
														</template>
														<template v-else>
	                        		<v-select class="w-100 mb-3" :options="regencies" v-model="regencies_selected" @input="toggleSelectRegencies(regencies_selected)" label="name"></v-select>
														</template>
													</template>
                        </div>
                        <p class="mb-0 mt-1 font-regular text-12 text-danger" v-if="form_validate.mitra_shop && validation_mitra_shop">Mohon pilih lokasi Provinsi dan Kabupaten/Kota yang tersedia</p>
                        <div class="py-3">
                        	<button type="button" class="button-primary w-100 overflow-hidden" v-if="is_load_state">
                        		<img src="../assets/icon/loading-white.gif" width="80" class="position-relative top_18" />
                        	</button>
                        	<button type="button" v-else class="button-primary w-100" @click="toggleSellTypeShop();toggleValidation('mitra_shop')">Jual Sekarang</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
	    	</template>
	    </transition>
	    <!-- POP UP LOCATION COD-->
	    <transition name="list">
				<template v-if="is_pop_up_location">
          <div class="position-relative">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom top-10" style="z-index: 1038;">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="px-4 bg-white rounded-top-6 position-relative popup-full">
                        <div class="pb-3 pt-4 border-bottom">
                        	<div class="d-block" @click="toggleBack('to-type')">
						                <img src="../assets/icon/left-arrow.svg" width="20" class="d-inline-block position-relative cursor-pointer" style="top: -2px">
	                        	<p class="mb-1 px-1 font-semibold text-16 ls-2 d-inline-block ml-2">Pilih Lokasi 
	                        		<span class="font-semibold text-16 ls-2 color-black" v-if="transaction_type == 'COD'">Pertemuan</span>
	                        		<span class="font-semibold text-16 ls-2 color-black" v-if="transaction_type == 'GOJEK'">Anda</span>
	                        	</p>
                        	</div>
                        	<p class="mb-0 font-regular text-12 ls-2 color-grey" v-if="transaction_type == 'COD'">Pilih lokasi rumah/tempat Anda ingin bertemu dengan mitra Goemas untuk proses transaksi.</p>
                        	<p class="mb-0 font-regular text-12 ls-2 color-grey" v-if="transaction_type == 'GOJEK'">Pilih lokasi rumah/tempat Anda ingin bertemu dengan driver Gojek untuk proses transaksi.</p>
                        </div>
                        <div class="pt-3">
                        	<form>
														<!-- MAPS -->
														<div class="mb-3">
															<GoogleMap @toggleSell="toggleSell" :is_load_state="is_load_state" :is_type="transaction_type"></GoogleMap>
														</div>
                        	</form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
	    	</template>
	    </transition>
	    <!-- POP UP LOCATION GOJEK-->
	    <transition name="list">
				<template v-if="is_pop_up_location_gojek">
          <div class="position-relative">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom" style="z-index: 1038;top: 35%;">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="mx-4 px-4 bg-white rounded-6 position-relative">
                        <div class="py-4 text-center">
                        	<GoogleMapGojek @toggleSell="toggleSell" :is_load_state="is_load_state" :is_type="transaction_type"></GoogleMapGojek>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
	    	</template>
	    </transition>
	    
	    <!-- POP UP TABEL GOLD -->
	    <transition name="fade">
				<template v-if="is_po_pup_tabel_gold">
          <div class="position-relative">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom top-0" style="z-index: 1038;">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="position-relative popup-full">
                        <!-- <div class="px-4 bg-white sticky py-3 top-0">
                        	<div class="d-block" @click="is_po_pup_tabel_gold = false">
						                <img src="../assets/icon/close.svg" width="18" class="d-inline-block position-relative cursor-pointer" style="top: -2px">
                        	</div>
                        </div> -->
                        <!-- Tabel Emas -->
												<div class="bg-white cursor-pointer" @click="popUpTabelGold()">
													<div class="border">
														<div class="bg-green-light p-3">
															<div class="row no-gutters">
																<div class="col-7">
																	<p class="mb-0 text-15 font-semibold">Karat</p>
																</div>
																<div class="col-5 text-right">
																	<p class="mb-0 text-15 font-semibold">Harga</p>
																</div>
															</div>
														</div>
														<div class="rouded-bottom px-3 pt-3">
															<div class="row no-gutters mb-3" v-for="data in get_quality_unit" v-if="data.type == 'gold'">
																<div class="col-7">
																	<p class="mb-0 text-14 font-medium">K{{data.name}}</p>
																</div>
																<div class="col-5 text-right">
																	<p class="mb-0 text-14 font-medium">Rp {{formatPrice(tableListPriceGold(data.murni))}} /g</p>
																</div>
															</div>
														</div>
													</div>
												</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
	    	</template>
	    </transition>
			<!-- BG Pop Up -->
	    <transition name="fade">
	    	<template v-if="is_pop_up || is_pop_up_location || is_pop_up_type || is_pop_up_location_gojek || is_pop_up_shop || is_po_pup_tabel_gold">
	        <div class="position-relative">
	          <div class="row no-gutters justify-content-center">
	            <div class="fixed-bottom d-block nav-bottom p-0">
	              <div class="custom-container-fluid px-0">
	                <div class="row justify-content-center no-gutters">
	                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
	                    <div class="w-100 bg-pop-up" @click="hideBgPopUp()">
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	    	</template>
	    </transition>
			<!-- Footer -->
			<footer>
				<div class="w-100 position-fixed w-100 mx-auto z-index-99" style="bottom: -1px">
				  <b-row no-gutters>
				    <b-col cols="12" sm="8" md="6" lg="4" xl="4">
							<div class="footer bg-white">
								<div class="container px-2 py-3">
									<div class="row text-center no-gutters">
										<div class="col-3">
											<div class="cursor-pointer d-table mx-auto" @click="toggleMenu('top')">
												<img src="../assets/icon/bold/Home.svg" width="auto" class="object-fit">
												<p class="mb-0 pt-1 font-medium text-12 color-green ls-2">Beranda</p>
											</div>
										</div>
										<div class="col-3">
											<div class="cursor-pointer d-table mx-auto" @click="toggleMenu('check-price-id')">
												<img src="../assets/icon/light/Chart.svg" width="auto" class="object-fit">
												<p class="mb-0 pt-1 font-regular text-12 color-grey ls-2">Cek Harga</p>
											</div>	
										</div>
										<div class="col-3 position-relative">
											<div class="cursor-pointer d-table mx-auto" @click="toggleMenu('how-to')">
												<img src="../assets/icon/light/Document.svg" width="auto" class="object-fit">
												<p class="mb-0 pt-1 font-regular text-12 color-grey ls-2">Cara Kerja</p>
											</div>
										</div>
										<div class="col-3">
											<router-link to="/login">	
												<img src="../assets/icon/light/Profile.svg" width="auto" class="object-fit">
												<p class="mb-0 pt-1 font-regular text-12 color-grey ls-2">Profil</p>
											</router-link>
										</div>
									</div>
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
			</footer>
	</div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex'
  import config from '@/config/index.js'

  import axios from 'axios'
  import Flickity from 'vue-flickity'
 	import vSelect from 'vue-select'
  
  import Header from '@/components/Header'
  import NavButton from '@/components/NavButton'
  import GoogleMap from '@/components/GoogleMap'
  import GoogleMapGojek from '@/components/GoogleMapGojek'
  
  import icon_time from '../assets/icon/time-left-black.svg'
  import icon_balance from '../assets/icon/balance-black.svg'
  import icon_loupe from '../assets/icon/loupe-black.svg'
  import dollar from '../assets/icon/dollar.svg'
  import covid from '../assets/icon/covid.svg'
  import profits from '../assets/icon/profits.svg'
  import sell from '../assets/icon/sell.svg'
  import logo from '../assets/logo.png'

	export default{
		metaInfo() {
	    return {
	      title: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi',
	      meta: [
	        { name: 'description', content: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi'},
	        { property: 'og:title', content: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi'},
	        { property: 'og:site_name', content: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi'},
	        { property: 'og:description', content: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi'},
	        { property: 'og:type', content: 'profile'},
	        { property: 'og:image', content: 'https://guestapps.s3-ap-southeast-1.amazonaws.com/website_general_setting/logo/133886c3-df9a-4393-809d-000393dbd68c_Untitled-2.png' }    
	      ]
	    }
	  },
		components: {
			Flickity,
			Header,
			NavButton,
			GoogleMap,
			GoogleMapGojek,
			vSelect
		},
		data() {
			return {
				cart: this.getCart(),
				loc_detail: [],
				transaction_type: '',
				is_pop_up: false,
				is_pop_up_type: false,
				is_pop_up_shop: false,
				is_pop_up_location: false,
				is_pop_up_location_gojek: false,
				is_po_pup_tabel_gold: false,
				phone_number: {
					sm: '',
					cod: '',
					shop: '',
					gojek: '',
				},
				is_learn_more: false,
				is_load: false,
				is_load_regencies: false,
				is_load_state: false,
				lat_lng_location: "",
				social_media: {},
        real_price: {
        	emas: '',
					harga_silver_500: '',
					harga_silver_925: ''
        },
        referensi_price: '',
				is_open: "gold",
				check_price: false,
				transaction_list: [
					{
						id: 'COD',
						title: "COD (Cash On Delivery)",
						desc: "Mitra akan datang ke lokasi yang Anda tentukan pada langkah berikutnya"
					},
					{
						id: 'AT_SHOP',
						title: "Toko Mitra",
						desc: "Anda datang ke toko mitra kami sesuai yang Anda tentukan pada langkah berikutnya"
					},
					{
						id: 'GOJEK',
						title: "Gojekin Aja",
						desc: "Silahkan gojekin emas/silver Anda ke alamat toko kami"
					},
				],
				product_category: [
					{
						name: "Buyback",
						type: "buyback",
						url: "",
						icon: sell,
						active: true
					},
					{
						name: "Investasi",
						type: "investasi",
						url: "investasi",
						icon: profits,
						active: false
					},
				],
				category: [
					{
						name: "Emas",
						type: "gold"
					},
					{
						name: "Silver",
						type: "silver"
					},
				],
				price: 0,
				form: {
					gram: '',
					carat: '',
					price: '',
					quality: '',
					title: '',
					murni: '',
					unit_id: ''
				},
				check_murni: '',
				focus: {
					gram: false,
					karat: false,
					map_name: false,
					keterangan: false,
				},
				flickityOptions: {
          initialIndex: 0,
          autoPlay: 3000,
	        prevNextButtons: false,
	        pageDots: false,
	        adaptiveHeight: true,
	        cellAlign: "left",
	        draggable: true,
	        wrapAround: true,
        },
        about_us: [
        	{
        		title: "Jual Dengan Cepat",
        		desc: "Jual emas/silver tanpa surat dengan cepat, mudah dan tanpa repot.",
        		icon: icon_time
        	},
        	{
        		title: "Ditimbang Oleh Ahli",
        		desc: "Emas/silver akan ditimbang dengan timbangan bersertifikat dan dilakukan oleh tenaga ahli dibidangnya.",
        		icon: icon_balance
        	},
        	{
        		title: "Transparan",
        		desc: "Setiap emas/silver yang anda jual akan kami analisis secara langsung dihadapan anda dengan memeriksa kadar kimianya untuk mendapatkan hasil yang tepat.",
        		icon: icon_loupe
        	},
        	{
        		title: "Harga Tertinggi",
        		desc: "Harga buyback Goemas selalu lebih tinggi dari harga buyback resmi dan tanpa biaya admin.",
        		icon: dollar
        	},
        	{
        		title: "COD Covid-19 Safety",
        		desc: "Kami memiliki prosedur keamanan covid-19 dan berkomitmen untuk menjaga anda tetap aman.",
        		icon: covid
        	},
        ],
        transaction_item: [],
        transaction_inquiry_id: null,
      	inquiry: {
			    location_name: '',
			    location_address: '',
			    google_map_url: '',
			    longitude: 0,
			    latitude: 0,
			    detail_transaction: [
		        {
		          item_type: '', 
	            weight: '', 
	            carat: '', 
	            murni: '', 
	            referensi: '', 
	            unit_id: ''
		        }
			    ],
			    new_customer: true,
			    customer_id: null,
			    trx_place_type: '',
			    province_id: '',
			    regency_id: ''
      	},
			  get_quality_unit: '',
			  murni: '',
			  provinces_id: '',
			  provinces: [],
			  provinces_selected: '',
			  regencies_id: '',
			  regencies: [], 
			  regencies_selected: '',
			  form_validate: {
			  	type_transaction: false,
			  	mitra_shop: false,
			  },
			  descending_unit: [],
			  center: { lat: 0, lng: 0 },
        markers: [],
        places: [],
			}
		},
		computed: {
			megic_price(){
				return config.megic_price
			},
			murni_price(){
				return config.murni_price
			},
			isPrice(){
				let display = 0
				if (this.is_open == 'gold') {
					if (this.check_murni) {
						display = Math.round((this.real_price.emas/1000) * this.murni_price * this.form.carat * this.form.gram)
					}else{
						display = Math.round((this.form.murni/1000) * this.real_price.emas * this.form.gram)
					}
				}else{
					if (this.form.quality == '925') {
						display = Math.round(this.form.gram * this.real_price.harga_silver_925)
					} else {
						display = Math.round(this.form.gram * this.real_price.harga_silver_500)
					}
				}
				return display
			},
			carat_18(){
				return Math.ceil((this.real_price.emas/1000) * this.megic_price * 18 * 1)
			},
			carat_14(){
				return Math.ceil((this.real_price.emas/1000) * this.megic_price * 14 * 1)
			},
			carat_9(){
				return Math.ceil((this.real_price.emas/1000) * this.megic_price * 9 * 1)
			},
			quality_925(){
				return this.real_price.harga_silver_925 * 1
			},
			quality_500(){
				return this.real_price.harga_silver_500 * 1
			},
			real_price_silver_price(){
				let display = 0
				if (this.form.quality == '925') {
					display = this.real_price.harga_silver_925
				}else{
					display = this.real_price.harga_silver_500
				}
				return display
			},
			real_price_silver_quality(){
				let display = 0
				if (this.form.quality == '925') {
					display = "silver jenis kualitas 925 karat"
				}else{
					display = "silver jenis kualitas 500 karat"
				}
				return display
			},
			validation_type_transaction(){
				let display = false
				if (this.transaction_type == ''){
					display = true
				}else{
					display = false
				}
				return display
			},
			validation_mitra_shop(){
				let display = false
				if (this.provinces_selected == '' || this.regencies_selected == '' || this.provinces_selected == null || this.regencies_selected == null){
					display = true
				}else{
					display = false
				}
				return display
			},
			validation_location(){
				if (this.lat_lng_location == '') {
					return false
				}else{
					return true
				}
			}
		},
		mounted(){
			document.getElementById('top').scrollIntoView({
        behavior: 'smooth'
      });
			this.getApiPrice()
			this.getApiUnit()
			this.getApiProvinces()
			this.getApiSocialMedia()
			this.geolocate()
		},
		methods:{
			...mapGetters([
				'getCart',
				'getCartTotal'
			]),
			...mapMutations([
				'setCart',
				'setDeleteCart',
				'setResetCart'
			]),
			getApiPrice(){
				this.is_load = true
				let res = ''
				axios
		      .get(config.API+'/form-data/latest-rates')
		      .then(response => {
		      	res = response.data
		      	this.real_price.emas = res.gold_sell
		      	this.real_price.harga_silver_500 = res.silver_500_sell
		      	this.real_price.harga_silver_925 = res.silver_sell_925
						this.is_load = false
		      })
			},
			getApiUnit(){
				this.is_load = true
				axios
		      .get(config.API+'/form-data/unit-list')
		      .then(response => {
		      	this.get_quality_unit = response.data
		      	this.descending_unit = JSON.parse(JSON.stringify(this.get_quality_unit))
						this.is_load = false
						this.descendingUnit(this.descending_unit)
		      })
			},
			getApiProvinces(){
				this.is_load = true
				axios
		      .get(config.API+'/form-data/provinces')
		      .then(response => {
		      	this.provinces = response.data
						this.is_load = false
		      })
			},
			getApiRegencies(){
				this.is_load_regencies = true
				axios
		      .get(config.API+'/form-data/regencies?province_id='+this.provinces_id)
		      .then(response => {
		      	this.regencies = response.data
		      	this.is_load_regencies = false
		      })
			},
			getApiSocialMedia(){
				this.is_load = true
				let res = ''
				axios
					.get(config.API+'/general-setting-social-media')
					.then(response => {
						res = response.data
						this.social_media = res
						this.phone_number.sm = res.whatsapp_sm
						this.phone_number.cod = res.whatsapp_sm_cod
						this.phone_number.shop = res.whatsapp_sm_shop
						this.phone_number.gojek = res.whatsapp_sm_gojek
						this.is_load = false
					})
			},
			getGeolocation(lat, lng){
      	axios.get(config.API+'/get-location-from-coor?lat='+lat+'&long='+lng+'')
      	.then(response => {
      		if (lat == 0 && lng == 0) {
      			this.lat_lng_location = '-'
      		}else{
      			this.lat_lng_location = response.data.data.formatted_address
      		}
      	})
      },
			postInquiry(data, type){
				if (type == 'GOJEK') {
					this.inquiry = {
				    location_name: this.lat_lng_location,
				    location_address: data.keterangan,
				    google_map_url: "https://www.google.co.id/maps/place/"+data.lat+','+data.lng,
				    longitude: this.center.lng,
				    latitude: this.center.lat,
				    detail_transaction: this.getCart(),
				    trx_place_type: this.transaction_type,
				    province_id: this.provinces_id,
				    regency_id: this.regencies_id
	      	}
      		this.postApiInquiry(type)
				}else {
					this.inquiry = {
				    location_name: data.address,
				    location_address: data.keterangan,
				    google_map_url: "https://www.google.co.id/maps/place/"+data.lat+','+data.lng,
				    longitude: data.lng,
				    latitude: data.lat,
				    detail_transaction: this.getCart(),
				    trx_place_type: this.transaction_type,
				    province_id: this.provinces_id,
				    regency_id: this.regencies_id
	      	}
      		this.postApiInquiry(type)
				}
			},
			geolocate() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.markers = [];
          this.markers.push({ position: this.center });
      		this.getGeolocation(this.center.lat, this.center.lng)
        });
      },
			postApiInquiry(type){
				this.is_load_state = true
				let res = ''
      	var fd = new FormData();
      	console.log("inquiry", this.inquiry)
				fd.append('newItem', JSON.stringify(this.inquiry));
      	axios.post(config.API+'/unquiry',fd).then(response => {
      		if (response.data.success) {
	      		res = response.data.id
	      		this.transaction_inquiry_id = res
		      	window.location.href = this.list_product_whatsapp(type)
		      	this.setResetCart()
		      	this.hideBgPopUp()
		      	this.transaction_type = ''
						this.toggleMenu('check-price-id')
						this.is_load_state = false
		      }else{
						this.is_load_state = false
		      	console.log("Message: ", response.data.message)
		      }
      	})
			},
			tableListPriceGold(data){
				return Math.round((data/1000) * this.real_price.emas)
			},
			tableListPriceSilver(data){
				let display = 0
				if (data == '925') {
					display = Math.round(this.real_price.harga_silver_925)
				} else {
					display = Math.round(this.real_price.harga_silver_500)
				}
				return display
			},
			toggleLocation(step){
				if (step == '2') {
					this.is_pop_up = false
					this.is_pop_up_type = true
				}else if (step == '3' && this.transaction_type == 'COD') {
					this.is_pop_up_location = true
					this.is_pop_up = false
					this.is_pop_up_type = false
				}else if (step == '3' && this.transaction_type == 'AT_SHOP') {
					this.is_pop_up = false
					this.is_pop_up_type = false
					this.is_pop_up_shop = true
				}else if (step == '3' && this.transaction_type == 'GOJEK') {
					// let location = {
					// 	address: "",
				 //    keterangan: "",
				 //    lng: "",
				 //    lat: "",
					// }
					this.is_pop_up_location_gojek = true
					this.is_pop_up = false
					this.is_pop_up_type = false
				}
			},
			toggleTransactionType(id){
				this.transaction_type = id
			},
			hideBgPopUp(){
				this.is_pop_up = false
				this.is_pop_up_type = false
				this.is_pop_up_location = false
				this.is_pop_up_location_gojek = false
				this.is_pop_up_shop = false
				this.is_po_pup_tabel_gold = false
			},
			toggleProductCategory(data){
				window.location.href = data
			},
			toggleOpen(data){
				this.is_open = data
				this.check_price = false
				this.form.gram = ''
				this.form.carat = ''
				this.form.price = ''
				this.form.title = ''
				this.form.quality = ''
			},
			toggleSelectCarat(data){
				this.form.quality = data.quality
				this.form.carat = data.carat
				this.form.murni = data.murni
				this.form.title = data.title
				this.form.unit_id = data.id
				this.toggleMenu('check-price')
			},
			toggleCheckPrice(){
				this.check_price = !this.check_price
			},
			toggleForm(type, id){
				if (type == 'focus') {
					this.focus[id] = true
				}else{
          this.focus[id] = false 
				}
			},
			formatPrice(value) {
        let val = (value/1)	
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    	},
    	toggleMenu(data){
    		window.addEventListener('scroll', this.updateScroll);
		    document.getElementById(data).scrollIntoView({
		      behavior: 'smooth'
		    });
    	},
    	toggleLearnMore(){
    		this.is_learn_more = !this.is_learn_more
    	},
    	toggleEmpty(){
    		this.form.gram = ''
				this.form.carat = ''
				this.form.price = ''
				this.form.title = ''
				this.form.quality = ''
    	},
    	togglePopUp(){
    		this.toggleEmpty()
    		this.is_pop_up = !this.is_pop_up
    		this.toggleMenu('check-price')
    	},
    	toggleBack(id){
    		if (id == 'to-item') {
    			this.is_pop_up_type = false;
    			this.is_pop_up = true;
    		}else if (id == 'to-type') {
    			this.is_pop_up_type = true;
    			this.is_pop_up_shop = false
    			this.is_pop_up_location = false;
    		}
    	},
    	toggleCart(){
    		let type = ''
    		let value = ''
    		let carat = ''
    		let referensi_price = ''
    		this.transaction_item = JSON.parse(JSON.stringify(this.getCart()))
    		if (this.is_open == 'gold') {
    			type = 'emas'
    			value = 'GOLD'
    			carat = this.form.quality
    			referensi_price = this.real_price.emas
    		}else{
    			type = 'silver'
    			value = 'SILVER'
    			carat = this.form.quality
    			referensi_price = this.real_price_silver_price
    		}
    		let trx_item = {
    			id: this.uuid(),
    			item_type: value ,
          weight: this.form.gram,
          carat: carat,
          murni: this.form.murni,
          referensi: referensi_price,
    			price: this.isPrice,
    			unit_id: this.form.unit_id
    		}
    		if (this.isPrice != 0) {
    			this.transaction_item.push(JSON.parse(JSON.stringify(trx_item)))
    			this.setCart(JSON.parse(JSON.stringify(this.transaction_item)))
    			this.is_pop_up = true
    		}
    		this.toggleEmpty()
    	},
    	toggleDeleteCart(data){
    		this.setDeleteCart(data)
    	},
    	uuid(){
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			    return v.toString(16);
			  });
			},
			toggleSell(data, type){
				this.loc_detail = data
				this.postInquiry(data, type)
			},
			focusRefs(data){
				this.$refs[data].focus()
			},
			popUpTabelGold(){
				this.is_po_pup_tabel_gold = !this.is_po_pup_tabel_gold
			},
			toggleSelectProvinces(data){
				if (this.provinces_selected !=  null && this.provinces_selected !=  '') {
					this.provinces_id = data.id
					this.getApiRegencies()
					this.regencies_selected = ''
				}
			},
			toggleSelectRegencies(data){
				this.regencies_id = data.id
			},
			toggleSellTypeShop(){
				if (!this.validation_mitra_shop) {
					let location = {
						address: "",
				    keterangan: "",
				    lng: "",
				    lat: "",
					}
					console.log("toggleSellTypeShop", location)
					this.postInquiry(location, 'AT_SHOP')
				}
			},
			toggleValidation(data){
				if (data == 'type_transaction' && this.validation_type_transaction) {
					this.form_validate.type_transaction = true
				}else if(data == 'mitra_shop' && this.validation_mitra_shop){
					this.form_validate.mitra_shop = true
				}
			},
			list_product_whatsapp(id){
				let display = ''
				let wa = {
					url: 'https://api.whatsapp.com/send?text=',
					phone_number: '&phone=',
					// url: 'https://api.whatsapp.com/send?phone='+this.phone_number+'&text=',
					greeting: 'Halo%20Tim%20GOEMAS,%20Saya%20ingin%20menjual%20:%0a%0a',
					total: '%0a%0aTotal%20pembayaran%20:%20Rp%20'+this.formatPrice(this.getCartTotal())+'',
					penawaran: '%0a%0aSesuai%20penawaran%20harga%20tertinggi%20yang%20anda%20akan%20berikan%20melalui%20aplikasi%20GOEMAS.',
					location_name: '%0a%0aLokasi%20:%20'+this.loc_detail.address+'%0aKeterangan%20:%20'+this.loc_detail.keterangan+'%0a',
					location_url: 'https://www.google.co.id/maps/place/'+this.loc_detail.lat +','+this.loc_detail.lng+'',
					shop_type: '%0a%0aTipe%20Transaksi%20:%20Toko%20Mitra',
					gojek_type: '%0a%0aTipe%20Transaksi%20:%20Gojekin',
					shop_location: '%0aLokasi%20:%20'+this.regencies_selected.name+',%20'+this.provinces_selected.name+'',
					note: '%0a%0aTerimakasih.%0aNOTE:',
					id_transaction: '%0aId%20Transaksi:%20*'+this.transaction_inquiry_id+'*'
				}
				let loop = ''
				let list = this.getCart()
				for(let i = 0; i < list.length; i++){
					let text_emas = '%0a'+this.formatTypeItem(list[i].item_type)+'%20'+'%20dengan%20berat%20'+list[i].weight+'%20gram,%20jenis%20kualitas%20'+list[i].carat+'%20karat%20dan%20seharga%20Rp%20'+this.formatPrice(list[i].price)+'%0a(%20Referensi%20transaksi%20ini%20IDR:%20'+this.formatPrice(list[i].referensi)+'%20/%20gr%20emas%20murni)'
					let text_silver = '%0a'+this.formatTypeItem(list[i].item_type)+'%20dengan%20berat%20'+list[i].weight+'%20gram,%20jenis%20kualitas%20'+list[i].carat+'%20karat%20dan%20seharga%20Rp%20'+this.formatPrice(list[i].price)+'%0a(%20Referensi%20transaksi%20ini%20IDR:%20'+this.formatPrice(list[i].referensi)+'%20/%20gr%20silver%20kualitas%20'+list[i].carat+')'
					if (list[i].item_type == 'GOLD') {
						loop += text_emas + "%0a"
					}else{
						loop += text_silver + "%0a"
					}
				}
				if (id == 'COD') {
					display = wa.url+wa.greeting+loop+wa.total+wa.penawaran+wa.location_name+wa.location_url+wa.id_transaction+wa.note+wa.phone_number+this.phone_number.cod
				}else if(id == 'AT_SHOP'){
					display = wa.url+wa.greeting+loop+wa.total+wa.penawaran+wa.shop_type+wa.shop_location+wa.id_transaction+wa.note+wa.phone_number+this.phone_number.shop
				}else{
					display = wa.url+wa.greeting+loop+wa.total+wa.penawaran+wa.gojek_type+wa.id_transaction+wa.note+wa.phone_number+this.phone_number.gojek
				}
				return display
			},
			descendingUnit(data){
				let a = data
				a.sort((a,b)=> (a.murni < b.murni ? 1 : -1))
				this.descending_unit = a
			},
			formatTypeItem(id){
				let display = ''
				if (id == 'GOLD' || id == 'gold') {
					display = 'Emas'
				}else{
					display = 'Silver'
				}
				return display
			}
		}
	}
</script>
<style scoped>
	
	/*Hero*/
	.hero-opacity{
		background-color: rgba(0, 0, 0, 0.5);
		height: auto;
	}

	.question-bg{
		background-image: url(../assets/img/accessories.jpg);
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
	
	.question-opacity{
		background-color: rgba(0, 0, 0, 0.6);
	}

	.carousel-cell {
	  width: 50%; /* half-width */
	  margin-right: 10px;
	}

	.bg-banner-gold{
		background-image: url(../assets/img/banner-gold.jpg);
		background-size: contain;
		background-position: 0 100%;
		background-repeat: no-repeat;
		background-color: #fdfdfd;
	}

	.bg-banner-silver{
		background-image: url(../assets/img/banner-silver.jpg);
		background-size: contain;
		background-position: 0 100%;
		background-repeat: no-repeat;
		background-color: #fffdee;
	}


	/*new*/
	.bg-green-light{
	  background-color: #d9eae2;
	}

	.border-green {
	  border-color: var(--color-primary)!important;
	}

	select.select-icon {
	  /*hide arrow*/
	  -webkit-appearance: auto;
	  -moz-appearance: auto;
	  text-indent: 1px;
	  text-overflow: '';
	}

	select:required:invalid {
	  color: #d8d8d8!important;
	  font-family: Poppins-Regular!important;
	  font-size: 14px;
	}

	option[value=""][disabled] {
	  display: none;
	}

	option {
	  color: black;
	}

	.radio-button{
	  width: 22px;
	  height: 22px;
	  border: 2px solid #dee2e6;
	  border-radius: 100%;
	}
	.radio-button .active{
	  background-color: var(--color-primary);
	  width: 12px;
	  height: 12px;
	  border-radius: 100%;
	  margin: auto;
	  position: absolute;
	  top: 0;
	  left: 0;
	  right: 0;
	  bottom: 0;
	}
/*
@media screen and (max-width: 369px) {
	.c-popup-full {
    height: 100vh;
    overflow-y: auto;
    padding-bottom: 1.5rem;
  }
  .top-20{
  	top: 20px;
  	bottom: none!important;
  }
}*/

</style>


// WEBPACK FOOTER //
// src/pages/HomePageDesktop.vue